export function type(obj) {
    const toString = Object.prototype.toString
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    }

    return map[toString.call(obj)]
}

// 唯一键值
export function genVTK() {
    const t = 'xxxxxxxx'
    return t.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

// 对象递归相等判断
export function isObjEqual(source, target) {
    if (type(target) === "object") {
        if (type(source) !== "object") {
            return false
        }

        return Object.keys(target).every(key => isObjEqual(source[key], target[key]))
    }

    if (type(target) === "array") {
        if (type(source) !== "array") {
            return false
        }

        return target.every((t, i) => isObjEqual(source[i], t))
    }

    return source === target
}